import React from 'react';
import { IPotentialMatch } from './IPotentialMatch';
import { Form, Formik } from 'formik';
import { ICheckForm } from './Forms';
import { IEscrowExpectedIncomingAchData } from 'types/accounting/data/IEscrowExpectedIncomingAchData';
import { IncomingCheckValidationSchema } from 'components/order/fees/incomingFunds/IncomingCheckDepositValidationSchema';
import { ExpectedSimpleForm } from './ExpectedSimpleForm';

export interface IConfirmCheckFormProps {
  potentialMatch: IPotentialMatch;
  createExpected: (x: ICheckForm) => void;
  amountCents: number;
  amountCentsMax: number;
}

const achToForm = (achData?: IEscrowExpectedIncomingAchData) => {
  if (!achData) {
    return undefined;
  }
  const { amountCents, category } = achData;
  return { amountCents, category };
};

export const ConfirmCheckForm: React.FC<IConfirmCheckFormProps> = ({
  potentialMatch,
  createExpected,
  amountCents,
  amountCentsMax,
}) => {
  const initialValuesConversion: ICheckForm =
    potentialMatch.expectedWire || achToForm(potentialMatch.expectedACH) || ({ amountCents } as ICheckForm);

  const initialValues = {
    ...initialValuesConversion,
    version: 'v2-accounting',
  };
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={createExpected}
      validationSchema={IncomingCheckValidationSchema({ amountCentsMax })}
    >
      {() => (
        <Form>
          <div className={'text-left text-lg font-semibold'}>Please confirm expected check information</div>
          <ExpectedSimpleForm />
        </Form>
      )}
    </Formik>
  );
};
